import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEQuickBuy from './CEQuickBuy.jsx';

const initQuickBuy = () => {
  const element = document.getElementById('quick-buy-react');

  if (!element) {
    console.warn('Quick Buy element not found');
    return;
  }

  // Read data attributes from the HTML element
  const locale = element.getAttribute('data-locale');
  const country = element.getAttribute('data-country');
  const market = element.getAttribute('data-market');

  createRoot(element).render(<CEQuickBuy localization={{ locale, country, market }} />);
};

initQuickBuy();
